import { render } from "./complianceControls.vue?vue&type=template&id=59d51558&scoped=true&ts=true"
import script from "./complianceControls.vue?vue&type=script&lang=ts"
export * from "./complianceControls.vue?vue&type=script&lang=ts"

import "./complianceControls.vue?vue&type=style&index=0&id=59d51558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d51558"]])

export default __exports__